module.exports = __webpack_public_path__ + "static/media/logo-white.7dfc9a6b.png";